import React, { Component } from 'react';
import { Route, Switch, Redirect} from 'react-router-dom';

import StillImageSticker from './guide/StillImageSticker';
import AnimatedSticker from './guide/AnimatedSticker';
import HowToUse from './guide/HowToUse';
import BasicPack from './guide/BasicPack';
import PlusPack from './guide/PlusPack';
import RejectedReasons from './guide/RejectedReasons';
// import Inspiration from './guide/Inspiration';
import Channel from './guide/Channel';
import SelectTags from './guide/SelectTags';
import FAQ from './FAQ';


class Guide extends Component{

  render(){
    return (
      <div>
        <Switch>
          <Redirect exact from="/guide" to="/guide/PLUS"/>
          <Route path="/guide/BASIC" component={BasicPack}/>
          <Route path="/guide/PLUS" component={PlusPack}/>
          <Route path="/guide/stillImageSticker" component={StillImageSticker}/>
          <Route path="/guide/animatedSticker" component={AnimatedSticker}/>
          <Route path="/guide/selectTags" component={SelectTags}/>
          {/* <Route path="/guide/inspiration" component={Inspiration}/> */}
          <Route path="/guide/channel" component={Channel}/>
          <Route path="/guide/rejectedReasons" component={RejectedReasons}/>
          <Route path="/guide/faq" component={FAQ}/>
          <Redirect exact from="/guide/:params" to="/guide/PLUS"/>
        </Switch>
      </div>
    );
  }

}
export default Guide;
